export enum PharmacyAddedByType {
  PHARMACY = 'PHARMACY',

  PHARMACIST = 'PHARMACIST',
}
